module.exports = __webpack_public_path__ + "static/media/about-image-second.bd845c02.png";